import React, { useCallback } from 'react';

import { NumberInput } from '@lyearn/ui';

import { FilterInputProps } from '../types';
import { getRatingMaxValue } from './consts';

function FilterInputRating(props: FilterInputProps) {
  const { value, onChange: onChangeProp, field } = props;
  const maxValue = getRatingMaxValue(field.metadataField.validation?.maxValue);

  const onChange = useCallback(
    (nextValue: number) => {
      onChangeProp(isNaN(nextValue) ? '' : nextValue.toString());
    },
    [onChangeProp],
  );

  return (
    <NumberInput
      autoFocus
      canBeEmpty
      max={maxValue}
      min={1}
      size="medium"
      value={parseInt(value || '', 10)}
      onChange={onChange}
    />
  );
}

export default FilterInputRating;
